import styled, {css} from 'quickstart/styled-components/system'

/**
 * The root element of every block-configuration form.
 *
 * Classic's dialog typography is asserted here because the classic admin sets
 * verdana at `font-size: medium` on `body` and its dialogs step that down; a
 * React root inside one would otherwise render at body size. `button` and `p`
 * are named separately because neither inherits font from an ancestor.
 *
 * Under the reskin nothing is declared. The admin's own `body` supplies
 * `--t-font` at `--t-text-base`, and the classes this project renders into
 * carry their own type where it differs (`.t-button`, `.t-field-lbl-txt`,
 * `.t-input`). Re-asserting a font here would be reproducing an appearance
 * the admin owns, which is what this change exists to stop — and it would
 * apply verdana at 10.9px to every reskin control in every form.
 */
export const AdminWrapper = styled.div<{$reskin?: boolean}>(({$reskin}) =>
  $reskin
    ? null
    : css`
        && {
          font-family: verdana, sans-serif;
          font-size: 0.68rem;
          button,
          p {
            font-family: verdana, sans-serif;
            font-size: 0.68rem;
          }
        }
      `,
)
